module.exports = __webpack_public_path__ + "static/media/navbar-login.d6bd563f.png";